import { render, staticRenderFns } from "./MessagesReport.vue?vue&type=template&id=d88709ca&"
import script from "./MessagesReport.vue?vue&type=script&lang=js&"
export * from "./MessagesReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports